import anime from 'animejs/lib/anime.es.js';
require("babel-core/register");
require("babel-polyfill");
import '../sass/main.sass';
import {loadAdmin} from '../javascript/admin.js';
import {loadStore, getStoreList} from '../javascript/store.js';
import {cart, openCart, orderDetails, orderDetailsToCart, renderCartPage} from '../javascript/cart.js';
let cartCheck = cart;
let styles = [];
let packageList = [];
let artList = [];
let artOrderList = [];
let bioPics = [];
let currentMenu = 'mob';
let inMotion = false;

const mobileMenu = `
    <nav class='mobile-nav'>
        <div style='position:relative;'>
            <div data-menuOpen class='press' style='position:absolute;min-height:100%;min-width:90%;z-index:100'></div>
                <i class="bars far fa-bars fa-2x"></i>
        </div>
        
        <div data-nav='Store' class='press mobile-nav-item'>Shop</div>
        <div data-nav='Contact' class='press mobile-nav-item'>Contact</div>
    </nav>
`;

const dskMenu = `
    <nav class='desk-nav'>
        <div data-nav='Store' class='press dsk-nav-item'>Shop</div>
        <div data-nav='Contact' class='press dsk-nav-item'>Contact</div>
    </nav>
`;

let menuContent = mobileMenu;

//console.log(winWidth);
$(window).resize(function() {
    //console.log('trying to adjust')
    adjustMenu().then(function() {
        loadHeader();
    });

})

function adjustMenu() {
    let winWidth = $(window).width();
    // console.log(winWidth,currentMenu)
    if(winWidth>600) {

        if(currentMenu!=='desk') {
            currentMenu = 'desk';
            // menuContent = dskMenu

            //console.log('changing to desk');
        }

    } else {
        if(currentMenu!=='mob') {
            currentMenu = 'mob';
            // menuContent = mobileMenu
            //console.log('changing to mob');
        }

    }
    return new Promise((resolve,reject) => {
        resolve(currentMenu);
    })
}


const menu = () => {
    return `
        <div class='top-bar'>
            <div class='flexr'>
            <div data-nav='Home' class='press site-logo'>Demo Art Gallery</div>
            
            </div>
            <div class='cartImg-set'></div>

            ${menuContent}

        </div>
    `;
}

// $('header').on('click','#returnToP',function() {

// })

function loadHeader() {
    // console.log('loading Header')
    adjustMenu().then(function(res) {
        //console.log(res)
        $('header').html(menu());
        if(res=='mob') {
            hideMenu('0');
        }

        menuClicks();
        if(tempDetails && tempDetails.cart) {
            showCartHeader(tempDetails.cart);
        }
        
    });

}

function menuClicks() {
    //console.log('menuclicks is running');
    $("header").off('click').on('click',function(e) {
        //console.log(e.target);
        if($(e.target).is('[data-nav]')) {
            //console.log('navigating');
            let nav = $(e.target).attr('data-nav');
            //console.log(nav);
            // if(nav=='Home') {loadHome();}
            if(nav=='Cart') {openCart();}
            if(nav=='Store') {loadStore();}
            // if(nav=='Contact') {loadContact();}
            //eval('load'+nav+'()');
            hideMenu();
        }

        if($(e.target).is('[data-menuOpen]')) {
            if($('.nav-item').is(":visible")) {
                hideMenu();
                return
            }
            showMenu();
            return
        }



        hideMenu();
    });
}

export function waiting(container = '.content-set') {
    $(container).css('position','relative')
    console.log('waiting')
    if($('#waiting').length==0) {
        $(container).prepend(`<div id='waiting' class='waiting'></div>`);
        anime({
            targets: '#waiting',
            duration: 500,
            opacity: [0,1],
            scale: [.9,1],
            easing: 'easeInQuart'
        })

        var logoSvgData = {
            "v":"5.7.4","fr":29.9700012207031,"ip":0,"op":121.000004928431,"w":711,"h":400,"nm":"Comp 1","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":117.000004765508,"s":[-1080]}],"ix":10},"p":{"a":0,"k":[355,202,0],"ix":2,"l":2},"a":{"a":0,"k":[-2.5,-5,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":26,"nm":"Radial Wipe","np":7,"mn":"ADBE Radial Wipe","ix":1,"en":1,"ef":[{"ty":0,"nm":"Transition Completion","mn":"ADBE Radial Wipe-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":0,"nm":"Start Angle","mn":"ADBE Radial Wipe-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":3,"nm":"Wipe Center","mn":"ADBE Radial Wipe-0003","ix":3,"v":{"a":0,"k":[355.5,200],"ix":3}},{"ty":7,"nm":"Wipe","mn":"ADBE Radial Wipe-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":0,"nm":"Feather","mn":"ADBE Radial Wipe-0005","ix":5,"v":{"a":0,"k":0,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[180.477,180.477],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"d":[{"n":"d","nm":"dash","v":{"a":0,"k":1,"ix":1}},{"n":"o","nm":"offset","v":{"a":0,"k":267.058,"ix":7}}],"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-2.5,-5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":0,"k":25,"ix":2},"o":{"a":0,"k":27,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":119.000004846969,"s":[-45]}],"ix":10},"p":{"a":0,"k":[355,200,0],"ix":2,"l":2},"a":{"a":0,"k":[-2.5,-5,0],"ix":1,"l":2},"s":{"a":0,"k":[149.52,149.52,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":26,"nm":"Radial Wipe","np":7,"mn":"ADBE Radial Wipe","ix":1,"en":1,"ef":[{"ty":0,"nm":"Transition Completion","mn":"ADBE Radial Wipe-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":0,"nm":"Start Angle","mn":"ADBE Radial Wipe-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":3,"nm":"Wipe Center","mn":"ADBE Radial Wipe-0003","ix":3,"v":{"a":0,"k":[355.5,200],"ix":3}},{"ty":7,"nm":"Wipe","mn":"ADBE Radial Wipe-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":0,"nm":"Feather","mn":"ADBE Radial Wipe-0005","ix":5,"v":{"a":0,"k":0,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[180.477,180.477],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.427861005068,0.017396382987,0.811749398708,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"d":[{"n":"d","nm":"dash","v":{"a":0,"k":72,"ix":1}},{"n":"o","nm":"offset","v":{"a":0,"k":267.058,"ix":7}}],"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-2.5,-5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":140,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape Layer 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":117.000004765508,"s":[720]}],"ix":10},"p":{"a":0,"k":[355,200,0],"ix":2,"l":2},"a":{"a":0,"k":[-2.5,-5,0],"ix":1,"l":2},"s":{"a":0,"k":[69,69,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":26,"nm":"Radial Wipe","np":7,"mn":"ADBE Radial Wipe","ix":1,"en":1,"ef":[{"ty":0,"nm":"Transition Completion","mn":"ADBE Radial Wipe-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":0,"nm":"Start Angle","mn":"ADBE Radial Wipe-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":3,"nm":"Wipe Center","mn":"ADBE Radial Wipe-0003","ix":3,"v":{"a":0,"k":[355.5,200],"ix":3}},{"ty":7,"nm":"Wipe","mn":"ADBE Radial Wipe-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":0,"nm":"Feather","mn":"ADBE Radial Wipe-0005","ix":5,"v":{"a":0,"k":0,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[180.477,180.477],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.017396382987,0.463489681482,0.811749398708,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":23,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"d":[{"n":"d","nm":"dash","v":{"a":0,"k":1,"ix":1}},{"n":"o","nm":"offset","v":{"a":0,"k":267.058,"ix":7}}],"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-2.5,-5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":0,"k":78,"ix":2},"o":{"a":0,"k":140,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Shape Layer 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":120.0000048877,"s":[60]}],"ix":10},"p":{"a":0,"k":[355,200,0],"ix":2,"l":2},"a":{"a":0,"k":[-2.5,-5,0],"ix":1,"l":2},"s":{"a":0,"k":[127,127,100],"ix":6,"l":2}},"ao":0,"ef":[{"ty":26,"nm":"Radial Wipe","np":7,"mn":"ADBE Radial Wipe","ix":1,"en":1,"ef":[{"ty":0,"nm":"Transition Completion","mn":"ADBE Radial Wipe-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":0,"nm":"Start Angle","mn":"ADBE Radial Wipe-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":3,"nm":"Wipe Center","mn":"ADBE Radial Wipe-0003","ix":3,"v":{"a":0,"k":[355.5,200],"ix":3}},{"ty":7,"nm":"Wipe","mn":"ADBE Radial Wipe-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":0,"nm":"Feather","mn":"ADBE Radial Wipe-0005","ix":5,"v":{"a":0,"k":0,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[180.477,180.477],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.933314800262,1,0.036473631859,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"d":[{"n":"d","nm":"dash","v":{"a":0,"k":0,"ix":1}},{"n":"g","nm":"gap","v":{"a":0,"k":11,"ix":2}},{"n":"d","nm":"dash2","v":{"a":0,"k":95,"ix":3}},{"n":"g","nm":"gap2","v":{"a":0,"k":88,"ix":4}},{"n":"o","nm":"offset","v":{"a":0,"k":267.058,"ix":7}}],"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-2.5,-5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":140,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0}],"markers":[{"tm":121.000004928431,"cm":"1","dr":0}]
        }

      // Paste Your JSON Bodymovin Code Here

        const animation = bodymovin.loadAnimation({
            container: document.getElementById('waiting'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: logoSvgData
        })
    } else {
        // console.log('already there')
    }

    setTimeout(removeWaiting,20000);
}

export function removeWaiting() {
    if(!inMotion && $('#waiting').length > 0) {
        inMotion = true
        // console.log('removing');
        anime({
            targets: '#waiting',
            scale: .9,
            opacity: 0,
            duration: 300,
            easing: 'easeOutQuad',
            complete: function() {
                $('#waiting').remove();
                // console.log('removed');
                inMotion = false
            }
        })
    } else {
        if($('#waiting').length > 0) {
            //console.log('already there');
        }
        if(inMotion) {
            //console.log('already in motion')
        }
    }


}


let tempDetails = orderDetails;
export function orderDetailstoIndex(updated) {
    tempDetails = updated;
}

function showMenu() {
    console.log('showing menu');
    let i = 27;
    $('.mobile-nav-item').each(function(e) {
        $(this).css('z-index', i);
        i--;
    })
    anime({
        begin: function() {
            $('.mobile-nav-item').css('display','flex')
        },
        targets: '.mobile-nav-item',
        translateX: [10,0],
        //translateY: [-50,0],
        //rotateZ: ['45deg','0deg'],
        //transformOrigin: "100%,100%,0",
        duration: 300,
        opacity: [0,1],
        easing: 'linear',
        delay: anime.stagger(100)
    });
    $('.nav-item').addClass('visible');
    // let content = `
    //     <div style='position:absolute;width:100%;height:100%;z-index:12;background:white;' id='body-cover'></div>
    // `;
    // $('body').prepend(content)
    $('body').on('click',function(e) {
        if($(e.target).parents('.mobile-nav').length) {
            console.log('menu-item')
        } else {
            hideMenu();
        }
    })
}

function hideMenu(dur = '400') {
    //console.log('hiding menu');
    //$('.nav-item').css('display','none');
    anime({
        targets: '.mobile-nav-item',
        translateX: [0,10],
        //translateY: [0,-50],
        //rotateZ: ['0deg','45deg'],
        //transformOrigin: "100% 100% 0",
        duration: dur,

        opacity: [1,0],
        easing: 'linear',
        delay: anime.stagger(100,{direction: 'reverse'}),
        complete: function() {
            $('.mobile-nav-item').css('display','none');
        }
    });
}







export function setStyles() {
    let content = '<style type="text/css">';
    styles.forEach((item) => {
        content += `${item.el} {`;
            if(item.style.length) {
                item.style.forEach((sty) => {
                    content += `${sty.property}: ${sty.value} !important;`
                })
            }

        content += `}`;

    })
    content += '</style>';
    $('head').append(content);
}

export function showCartHeader(cartHeaderVar) {
    //console.log(cartHeaderVar.length);
    if(cartHeaderVar && cartHeaderVar.length>0) {
        //console.log(cartHeaderVar);
        $('.cartImg-set').html(`
            <div data-nav='Cart' style='position:absolute;min-height:100%;min-width:100%;z-index:99'></div>
            <div class='cartImg'>
            <div ></div>
                <div  class='number'>${cartHeaderVar.length}</div>
                <i class="far fa-shopping-cart"></i>
            </div>`);
        $('.modalCartImg').removeClass('hide')
        $(`[data-nav='cart']`).on('click',function() {
            openCart()
        })
    } else {
        $('.cartImg-set').html('');
        $('.modalCartImg').addClass('hide')
    }

}

function loadArtList() {

    $.get("ajax/art.php?getArtList",function(data,status) {
        artList = JSON.parse(data);
        // console.log(artList, status);
    })
}

function loadPackageList() {
    $.ajax({
        url: "ajax/admin.php?getPackageList",
        success: function(data) {
        //    console.log(data);
            packageList = JSON.parse(data);

        }
    });
}

function loadBioPics() {
    return $.ajax({
        url: "ajax/admin.php?getBioPics",
        success: function(data) {
            //console.log(data);
            bioPics = JSON.parse(data);
            //console.log(bioPics);
            return new Promise((resolve,reject) => {
                resolve();
            })
        }
    });
}

function loadStyles() {
    return $.ajax({
        url: "ajax/admin.php?getStyle",
        success: function(data) {
            //console.log(data);
            styles = JSON.parse(data);
            styles.forEach((item, i) => {
                if(item.class.length) {
                    item.class = JSON.parse(item.class);
                }
                if(item.style.length) {
                    item.style = JSON.parse(item.style);
                }

            });
            //console.log(styles);
            return new Promise((resolve,reject) => {
                resolve()
            })
        }
    });
}

function loadHome() {
    // waiting('.content-set');
    let windowInner = window.innerHeight;
    let cartPageHeight = windowInner;
    if($(window).width() < 600) {
        //console.log('small window')
        $('.content-set').css('height',cartPageHeight);
    } else {
        //console.log('large window')
        $('.content-set').css('height',cartPageHeight);
    }
    //$(".content-set").html(home);
    $(".subHeader").hide();
    $('header').hide();
    let content = `
    <div class='bg'>
        <div class='black-block'>
        
        <h2>Grace</h2><h2 id='home2ndText'>Ann Art</h2>
        </div>
    </div>
        <div class='homeLink-set'>
            <p class='press homeLink' data-nav='Store'>View Art</p>
            <p class='press homeLink' data-nav='Bio'>Bio</p>
        </div>
    `;

    $(".content-set").html(`<div class='grace-container'>${content}</div>`);
    $('main').height('100%')
    $('.subHeader').hide();
    anime({
        before: function() {
            // removeWaiting();
            anime({
                targets: `.grace-container p`,
                translateY: 200,
                duration: 0,
                opacity: 0
            })
        },
        targets: `.grace-container h2`,
        // rotateZ: ['-40deg','0deg'],
        // translateZ: [0,0],
        // translateX: [30,0],
        // opacity: [0,1],
        webkitTextStroke: ['350px white','1px white'],
        // webkitStrokeWidth: ['200px','1px'],
        // rotateX: ['45deg','0deg'],
        // rotateY: ['20deg','0deg'],
        // translateY: [-10,0],
        duration: 2000,
        delay: 2000,
        // delay: anime.stagger(50,{start:500}),
        easing: 'cubicBezier(.1,.59,0,.97)',
        complete: function() {
            console.log('starting vine')
            // const animation = bodymovin.loadAnimation({
            //     container: document.getElementById('vine1'),
            //     renderer: 'svg',
            //     loop: true,
            //     autoplay: true,
            //     animationData: vine1,
            //     // path: vine1
            // })


        }
    })

    

    anime({
        targets: `.grace-container p`,
        translateY: 0,
        duration: 1400,
        opacity: 1,
        delay: anime.stagger(150,{start:1200}),
        easing: 'cubicBezier(0,.99,.68,1.01)',
        complete: function() {
            // waiting('.vine1')
        }
    })
    
    $('.grace-container').on('click',"[data-nav]",function() {
        let val = $(this).attr('data-nav');
        anime({
            targets: `.grace-container`,
            translateY: 50,
            duration: 300,
            opacity: 0,
            easing: 'cubicBezier(0,.99,.68,1.01)',
            complete: function() {
                
                $('header').show();
                anime({
                    targets: `header, .subHeader`,
                    translateY: [-50,0],
                    opacity: [0,1],
                    easing: 'cubicBezier(0,.99,.68,1.01)',
                    //delay: anime.stagger(200)
                })
                $('.subHeader').show();
                console.log(val);
                if(val=='Store') {
                    loadStore();
                }
                
            }
        })

    })



}



function artClicks() {
    console.log('ready for art clicks')
    $('.artImg').off('click').on('click',function(e) {
        //console.log('picture clicked');
        let artID = e.target.getAttribute('data-artID');
        let thisArt = artList.find(function(art) {
            return art.ID == artID
        });

        // viewLarger(thisArt);
    })

    $('[data-artInfo]').off('click').on('click',function(e) {
        let artID = $(this).attr('data-artInfo');
        if($("[data-artInfo-add='"+artID+"'").length > 0) {
            $('.artInfo-add').remove();
            $('[data-artInfo]').text('more info');
        } else {
            $('[data-artInfo]').text('more info');
            $('.artInfo-add').remove();
            let thisArt = artList.find(function(art) {
                return art.ID == artID
            });
            console.log(thisArt);
            let content = `
            <div class='artInfo-add' data-artInfo-add='${thisArt.ID}'>
                <p>${thisArt.medium}</p>
                <p>${thisArt.dim}</p>
                <h3>${thisArt.year}</h3>
            </div>
            `;
            $("[data-artSet-inside='"+artID+"']").append(content);
            $(this).text('hide');

        }

    })
}

function viewLarger(art,dir) {
    $('.artModal').remove();
    //console.log(art);
    let width = $(window).width();
    let folder = 'mid';
    console.log(width);
    if(width>500) {
        folder = 'gallery';
    }
    // craft content
    let content =  `
        <div id='viewing' class='artModal'>
            <div class='largeImg'>
                <div class='imageAndArrows'>
                    <div data-shift='up' class='press arrow arrow-left'><i class="fal fa-chevron-circle-left"></i></div>
                        <img class='image' src='https://www.squashinmotion.com/assets/grace/images/${folder}/${art.fileName}' >
                    <div data-shift='down' class='press arrow arrow-right'><i class="fal fa-chevron-circle-right"></i></div>
                </div>
                <h2>${art.title}</h2>
                <p>${art.description}</p>
                <h3>${art.year}</h3>
            </div>
        </div>`;

    // render content w/ animation
    $('body').prepend(content).ready(function() {
        let from = '';
        if(dir=='up') {from='-400px';} else {from='400px';}
        $('.artModal').velocity({translateX:from,opacity:0},0)
        .velocity({translateX:[0],opacity:[1]},{duration:600,easing:[.66,.15,0,1.21]});

        $('.art-set').velocity({blur:6},{duration:600,queue:false});
    });

    // setup clicks
    $('.arrow').off('click').on('click',function() {
        let where = $(this).attr('data-shift');
        let nextOrderNum = '';
        if(where=='up') {nextOrderNum = parseInt(art.orderNum)-1;}
        if(where=='down') {nextOrderNum = parseInt(art.orderNum)+1;}
        let nextArt = artList.find((next) => {
            return next.orderNum == nextOrderNum
        });
        console.log(art.orderNum,nextOrderNum,where);
        viewLarger(nextArt,where);
    });

    $(".image").off('click').on('click',function(e) {
        //console.log('artModal clicked');
        $('.artModal').velocity({translateX:[-400,0],opacity:[0,1]},{duration:600,easing:[.66,.15,0,1.21]}).ready(function() {
            $('.art-set').velocity({blur:0},200);
            $('.artModal').remove();
        })
    });

    // $('.artModal').on('swipe',function() {
    //     console.log('swiping!');
    // })


//<div class='artModalShop press'>view<br>in<br>shop</div>

}





function verifyLogin() {
    $.ajax({
        url: "ajax/admin.php?verifyLogin",
        success: function(data) {
        }
    })
    return 'true'
}





$( document ).ready(function() {
    //setTimeout(loadHeader,500);
    $.when(
        loadStyles(),
        loadBioPics()
    ).done(function() {
        setStyles()
    }).then(function() {
        let url = new URL(window.location.href);
        
        
            if(url.hostname == 'localhost') {
                if(url.pathname == '/ecomm_demo/admin.php') {
                    if(verifyLogin() == 'true') {
                        loadAdmin() 
                    } else {
                        $('#submit').on('click',function() {
                            let pass = $('#pass').val();
                            $.ajax({
                                method: "POST",
                                url: "ajax/admin.php?login",
                                data: {
                                    passit: pass
                                },
                                success: function(data) {
                                    //console.log(data)
                                    if(data=='true') location.reload();
                                }
                            });
                        })
                    }
                    
                } else if(url.searchParams.has('orderStatus')) {
                    adjustMenu().then(function() {
                        loadHeader();
                    });
                    openCart();
                } else {
                    adjustMenu().then(function() {
                        loadHeader();
                    });
                    console.log('come on store!')
                    loadStore();
                    //setAdminButton();
                }
            } else 
            if(url.pathname == '/admin.php') {
                loadAdmin();
                console.log(url.pathname)
            } else if(url.searchParams.has('orderStatus')) {
                adjustMenu().then(function() {
                    loadHeader();
                });
                openCart();
            } else {
                console.log(url.pathname)
                adjustMenu().then(function() {
                        loadHeader();
                    });
                loadStore();
                //console.log(url.pathname);
                //setAdminButton();
            }
        });
        
    })




// asd
    //console.log(url.search);



    //console.log(url.hostname, url.pathname);

    //openCart();


//loadHome();
